import { Box, Grid } from "@mui/material";
import React from "react";
import BorderedLayout from "../../../layouts/BorderedLayout";
import SellDetail from "./SellDetail";
import { GetSaleInformationSaleDetail } from "../../../models/settlement.model";
import PaymentDetail from "./PaymentDetail";

const SaleDetailTab = ({
  saleData,
  saleType,
}: {
  saleData: GetSaleInformationSaleDetail;
  saleType: string;
}) => {
  return (
    <Grid container sx={{ height: "100%" }} padding={{ xs: "0", md: "10px" }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{ height: "100%", paddingInline: { xs: "0", md: "10px" } }}
      >
        <BorderedLayout title="جزییات فروش">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              height: "100%",
              overflow: "auto",
            }}
          >
            <SellDetail
              creditAmount={saleData?.creditAmount}
              cashAmount={saleData?.cashAmount}
              totalAmount={saleData?.saleAmount}
              settlementAmount={saleData?.settlementAmount}
              taxAmount={saleData?.taxAmount}
              repaymentFeeAmount={saleData?.repaymentFeeAmount}
              saleItemsFeeAmount={saleData?.saleItemsFeeAmount}
              supplierSideLoanFeeAmount={saleData?.supplierSideLoanFeeAmount}
              walletDetail={saleData?.walletDetail}
              saleType={saleType}
              settlementNote={saleData?.settlementNote}
            />
          </Box>
        </BorderedLayout>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          height: "100%",
          paddingInline: { xs: "0", md: "10px" },
          // marginTop: { xs: "20px", md: "" },
        }}
        marginTop={{ xs: "20px", md: "0" }}
      >
        <BorderedLayout title="جزییات پرداخت">
          <Box sx={{ height: "100%", overflow: "auto" }}>
            <PaymentDetail
              saleDate={saleData?.paymentDetail?.saleDate_Persian}
              gatewayToken={saleData?.paymentDetail?.gatewayToken}
              factorNumber={saleData?.paymentDetail?.factorNumber}
              onlinePaymentInformation={
                saleData?.paymentDetail?.onlinePaymentInformation
              }
            />
          </Box>
        </BorderedLayout>
      </Grid>
    </Grid>
  );
};

export default SaleDetailTab;
